import React, { useEffect, useState, useContext } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Container, Autocomplete, TextField } from '@mui/material';
import { getCompaniesForDropdown } from '../../../api/GBENSDec';
import { useNavigate, useLocation } from 'react-router-dom';
import WarningIcon from '@mui/icons-material/Warning';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { StoreContext } from '../../../components/Store';
import { isEORIUser, is360PayStaff } from '../../../utils/roles';
import RequestUnitsModal from '../../Settings/Subscription/RequestUnitsModal';

export default function SelectCompanyForENS() {
  const navigate = useNavigate();
  const store = useContext(StoreContext);
  const { state } = useLocation();

  const [customer, setCustomer] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [inputValue, setInputValue] = useState('');
  const [value, setValue] = useState('');
  const [image, setImage] = useState('');
  const [isUnitsModalOpen, setIsUnitsModalOpen] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [eoriNumber, setEoriNumber] = useState('');
  const [companyNames, setCompanyNames] = useState('');

  const apiCall = () => {
    getCompaniesForDropdown().then((data) => {
      if (!isEORIUser() && data) {
        for (const element of data?.data) {
          if (sessionStorage.getItem('companyid') == element.companyId) {
            setValue(element.companyName);
            setCustomer([element]);
            setSelectedData((prevData) => {
              return {
                ...prevData,
                ['customer']: parseInt(sessionStorage.getItem('companyid')),
              };
            });
          }
        }
      } else {
        setCustomer(data?.data || []);
      }
    });
  };
  useEffect(() => {
    async function fetchData() {
      try {
        apiCall();
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (state?.res) {
      setSelectedData((prevData) => {
        return {
          ...prevData,
          ['customer']: state.res.companyId,
        };
      });
    }
  }, [state?.res]);

  const navigateToENS = () => {
    //using the id in selectedData.customer, find the customer object in the customer array, looking for the record where companyId matches selectedData.customer
    const currentCompany =
      Object.keys(selectedData).length === 0
        ? customer[0]
        : customer.find((company) => company.companyId === (selectedData.companyId || selectedData.customer));
    setCompanyNames(currentCompany.companyName);
    if (!isEORIUser()) {
      navigate('/EnsDeclaration', { state: { companyId: currentCompany.companyId, currentCompany: currentCompany } });
    } else {
      setIsConfirmModalOpen(true);
    }
  };
  const handleClose = () => setIsConfirmModalOpen(false);
  const handleNavigation = () => {
    const currentCompany =
      Object.keys(selectedData).length === 0
        ? customer[0]
        : customer.find((company) => company.companyId === (selectedData.companyId || selectedData.customer));
    navigate('/EnsDeclaration', {
      state: { companyId: currentCompany.companyId, currentCompany: currentCompany, image: image },
    });
  };

  const changeCompanyDropdown = (event, newValue) => {
    let binary = '';
    if (newValue?.logo?.data) {
      let bytes = new Uint8Array(newValue.logo?.data);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      setImage(btoa(binary));
    }
    setEoriNumber(newValue?.companyEori);
    setSelectedData((prevData) => {
      return {
        ...prevData,
        ['companyId']: newValue?.companyId,
      };
    });
    setValue(newValue?.companyName);
  };

  const hideDropdown = (!isEORIUser() && customer.length <= 1) || is360PayStaff();

  const InsufficientBalanceMessage = () => {
    return (
      <>
        Your current balance is 0 units, you are able to create an ICS2 declaration but you will not be able to submit
        to Customs until you have purchased additional units.
        <Box sx={{ mt: 2 }}>
          <Button variant="outlined" onClick={() => setIsUnitsModalOpen(true)}>
            Request Additional Units
          </Button>
        </Box>
      </>
    );
  };

  return (
    <Container maxWidth="lg">
      <Grid container className="two-column">
        <Grid item xs={3} className="two-column-divs left-container">
          <div>
            <p className="select-company-create-ens-sidetab">Create an ENS Declaration</p>
          </div>
        </Grid>
        <Grid item xs={9} className="two-column-divs right-container">
          <div style={{ padding: '20px 30px 20px 40px' }}>
            <p>The CABIE ICS2 Portal is designed for RORO Imports (Accompanied and Unaccompanied).</p>
            <p>
              To create an ENS Declaration you need the Transport and Journey details, and details of each consignment
              on the truck.
            </p>

            <div>
              <Autocomplete
                value={value}
                fullWidth
                className="form-input disabled"
                onChange={changeCompanyDropdown}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                id="controllable-states-demo"
                options={customer}
                sx={{ width: 300, marginTop: 3, backgroundColor: '#fff' }}
                getOptionLabel={(option) => {
                  return `${option.companyName || option}`;
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      {option.companyName || option}
                    </li>
                  );
                }}
                renderInput={(params) => <TextField {...params} label="Select Customer" />}
                hidden={hideDropdown}
              />
              {hideDropdown && (
                <div style={{ fontWeight: 'bold' }}>
                  {inputValue?.length && !is360PayStaff() ? (
                    <>{store.hasSufficientBalance ? `Your Company: ${inputValue}` : <InsufficientBalanceMessage />}</>
                  ) : (
                    <>You have no permission to create an ENS</>
                  )}
                </div>
              )}
            </div>
            <div className="select-company-footer">
              <a href="https://www.eori.uk/customs-knowledge/how-to-create-an-eu-ens" target="_blank">
                Quick start guide
              </a>
              <button onClick={navigateToENS} disabled={!value}>
                Create ENS
              </button>
            </div>
          </div>
        </Grid>
      </Grid>

      {!!customer?.length && (
        <RequestUnitsModal
          isOpen={isUnitsModalOpen}
          setIsOpen={setIsUnitsModalOpen}
          companyId={customer[0].companyId}
        />
      )}

      <Dialog
        open={isConfirmModalOpen}
        onClose={handleClose}
        className="select-company-modal"
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Box>
            <WarningIcon className="svg-icons select-company-modal-warning-icon" style={{ color: 'orange' }} />
            <span className="select-company-modal-title">Confirm ENS Customer</span>
          </Box>
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText className="select-company-modal-body">
            <p>Please confirm you are completing an ENS for the following customer</p>
            <div className="select-company-modal-text-and-image">
              <div className="select-company-modal-left-aligned-text">
                <span>{companyNames}</span>
                <span>{eoriNumber}</span>
              </div>
              {image && (
                <div
                  className="select-company-modal-image-display"
                  style={{ backgroundImage: `url('data:image/png;base64,${image}')` }}
                />
              )}
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'space-between' }}>
          <Button onClick={handleClose} className="button-class cancel-btton" sx={{ minWidth: 100 }}>
            Cancel
          </Button>
          <Button onClick={handleNavigation} className="button-class confirm-btton" sx={{ minWidth: 100 }}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
